export const GET_VISITS = 'visits/GET_VISITS'
export const GET_VISITS_SUCCESS = 'visits/GET_VISITS_SUCCESS'
export const REMOVE_VISIT_ITEM_BY_ID = 'visits/REMOVE_VISIT_ITEM_BY_ID'
export const GET_VISITS_ERROR = 'visits/GET_VISITS_ERROR'
export const VISITS_SET_ERROR = 'visits/VISITS_SET_ERROR'

export const GET_REMARKS = 'visits/GET_REMARKS'
export const GET_REMARKS_SUCCESS = 'visits/GET_REMARKS_SUCCESS'
export const GET_REMARKS_ERROR = 'visits/GET_REMARKS_ERROR'

export const CREATE_VISIT_REMARK = 'visits/CREATE_VISIT_REMARK'
export const CREATE_VISIT_REMARK_SUCCESS = 'visits/CREATE_VISIT_REMARK_SUCCESS'
export const CREATE_VISIT_REMARK_SUCCESS_ACTION = 'visits/CREATE_VISIT_REMARK_SUCCESS_ACTION'
export const CREATE_VISIT_REMARK_ERROR = 'visits/CREATE_VISIT_REMARK_ERROR'

export const RESOLVE_VISIT = 'visits/RESOLVE_VISIT'
export const RESOLVE_VISIT_SUCCESS = 'visits/RESOLVE_VISIT_SUCCESS'
export const RESOLVE_VISIT_ERROR = 'visits/RESOLVE_VISIT_ERROR'

export const GET_VISIT_INFO = 'visits/GET_VISIT_INFO'
export const GET_VISIT_INFO_SUCCESS = 'visits/GET_VISIT_INFO_SUCCESS'
export const GET_VISIT_INFO_ERROR = 'visits/GET_VISIT_INFO_ERROR'
export const CLEAR_VISIT_DATA = 'visits/CLEAR_VISIT_DATA'

export const CANCEL_VISIT = 'visits/CANCEL_VISIT'
export const CANCEL_VISIT_SUCCESS = 'visits/CANCEL_VISIT_SUCCESS'
export const CANCEL_VISIT_ERROR = 'visits/CANCEL_VISIT_ERROR'

export const CHANGE_VISIT_STATUS = 'visits/GHANGE_VISIT_STATUS'
export const VISITS_SET_DONT_REFRESH = 'visits/SET_DONT_REFRESH'

export const SET_IS_VISIT_STATUS_CHANGED_SUCCESS = 'visits/SET_IS_VISIT_STATUS_CHANGED_SUCCESS'

export const text = {
  PERIOD: 'Period',
  REMARK_MESSAGE: 'Remark message',
  THE_VISIT: 'The visit',
}
